import { client } from '../api';
import {
  ADDRESS_ENDPOINT,
  CHECKOUT_URL,
  CREATE_PASSWORD_ENDPOINT,
  CUSTOMER_ENDPOINT,
  UPDATE_PASSWORD_ENDPOINT,
  FORGOT_PASSWORD_ENDPOINT,
  VALIDATE_REQUEST_PASSWORD_TOKEN_ENDPOINT,
  RECOVER_FORGOTTEN_PASSWORD_ENDPOINT,
} from './constants';

export const updateCustomer = async (id, customer) =>
  await client.put(`${CUSTOMER_ENDPOINT}${id}/`, customer);

export const getCustomer = async id =>
  await client.get(`${CUSTOMER_ENDPOINT}${id}/`);

export const updatePassword = async password =>
  await client.put(UPDATE_PASSWORD_ENDPOINT, password);

export const createPassword = async password =>
  await client.put(CREATE_PASSWORD_ENDPOINT, password);

export const forgotPassword = async (email, token) => {
  return await client.post(FORGOT_PASSWORD_ENDPOINT, {
    email,
    'g-recaptcha-response': token,
  });
};

export const validateNewPasswordRequestToken = async (customer_id, token) => {
  return await client.post(
    VALIDATE_REQUEST_PASSWORD_TOKEN_ENDPOINT(customer_id),
    {
      token,
    },
  );
};

export const recoverForgottenPassword = async (customer_id, data) => {
  return await client.post(
    RECOVER_FORGOTTEN_PASSWORD_ENDPOINT(customer_id),
    data,
  );
};

export const updateAddress = (customerId, address) =>
  client.post(ADDRESS_ENDPOINT(customerId), address);

export const performCheckout = customerId =>
  client.post(CHECKOUT_URL(customerId));

export const formToModel = (address, customer) => ({
  address1: address.address,
  address2: address.apt,
  first_name: address.firstName || customer.first_name,
  last_name: address.lastName || customer.last_name,
  phone: address.phoneNumber,
  zip_code: address.zipCode,
  state: address.state,
  city: address.city,
  is_sms: address.smsUpdates,
});

export const modelToForm = (address, customer) => ({
  address: address.address1,
  apt: address.address2,
  firstName: address.first_name,
  lastName: address.last_name,
  phoneNumber: address.phone,
  zipCode: address.zip_code,
  state: address.state,
  city: address.city,
  smsUpdates: customer.is_sms || false,
});
